import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { Step1SvgComponent } from '../step-1/step-1.component';
import { Step2SvgComponent } from '../step-2/step-2.component';
import { Step3SvgComponent } from '../step-3/step-3.component';

@Component({
  selector: 'portal-steps-svg',
  imports: [Step1SvgComponent, Step2SvgComponent, Step3SvgComponent],
  templateUrl: './steps.component.html',
  styleUrl: './steps.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StepsSvgComponent {
  public step = input<number>();
}
